<template>
    <el-dialog title="选择用户" :visible.sync="visible" width="500px">
        <el-form label-width="110px">
            <el-form-item label="用户姓名" prop="user_uuids">
                <el-select
                    style="width: 100%"
                    v-model="form.user_uuids"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    placeholder="用户姓名"
                    :remote-method="remoteMethod"
                    :loading="loading"
                >
                    <el-option v-for="item in options" :key="item.uuid" :label="item.nick_name" :value="item.uuid"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { list } from "@/api/member/list";
import { add } from "@/api/member/relative";
export default {
    data() {
        return {
            form: {
                user_uuids: [],
            },
            visible: false,
            loading: false,
            options: [],
            uuid: "",
        };
    },
    methods: {
        open(uuid) {
            this.visible = true;
            this.uuid = uuid;
        },
        remoteMethod(query) {
            if (query !== "") {
                this.loading = true;
                list({ page_index: 1, page_size: 9999, search_keyword: query }).then(({ code, result, error }) => {
                    this.loading = false;
                    if (code == 200) {
                        this.options = result.data || [];
                    } else {
                        this.$message.error(error.message);
                    }
                });
            } else {
                this.options = [];
            }
        },
        handleConfirm() {
            add({ uuid: this.uuid, user_uuids: this.form.user_uuids }).then(({ code, error }) => {
                if (code == 200) {
                    this.$message.success("添加成功");
                    this.visible = false;
                    this.$emit("update");
                } else {
                    this.$message.error(error.message);
                }
            });
        },
    },
};
</script>

<style></style>
